import {Link} from "react-router-dom";
import LogoDark from "../../images/logo-dark.png";

const RegisterCompleted = () => {
    return (
        <div className="wrapper">
            <div className="wrapper-inner">
                <div className="content clearfix">
                    <div className="section-block replicable-content window-height bkg-heavy-rain-gradient">
                        <div className="row flex v-align-middle">
                            <div className="column width-6 offset-3">
                                <div>
                                    <div className="logo mb-50">
                                        <div className="logo-inner center">
                                            <Link to="/"><img src={LogoDark} width="125" alt="흑우촌 로고"/></Link>
                                        </div>
                                    </div>
                                    <div className="signup-box box rounded xlarge bkg-white shadow">
                                        <div className="row">
                                            <div className="column width-12 center">
                                                <h3 className="mb-50">회원가입 완료</h3>
                                            </div>
                                            <div className="column width-12">
                                                <blockquote className="icon large center">
                                                    <p>회원가입이 완료되어 바로 서비스를 이용하실 수 있습니다.</p>
                                                </blockquote>
                                            </div>
                                            <p className="mb-20 center">아직 클라이언트를 설치하지 못하였나요? <Link
                                                to="/download" className="fade-location">클라이언트 다운로드</Link></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    );
}

export default RegisterCompleted;